import React, { useCallback, useRef } from 'react'
import PropTypes from 'prop-types'
import FileUploader from 'devextreme-react/file-uploader'
import Validator from 'devextreme-react/validator'
import { RequiredRule } from 'devextreme-react/form'
import Button from 'devextreme-react/button'
import { useMediaQuery } from '@react-hooks-library/core'
// import settings from '../../configuration/config'

// const storeUrl = settings.STORE_URL

const FileField = ({ question, submit, next }) => {
  const accept = question.archivo_extensiones ?? '*'
  const required = question.es_obligatoria
  const defaultValue = question.respuesta_archivo?.split('/')[1]
  const button = useRef(null)
  const fileUploader = useRef(null)
  const isLargeScreen = useMediaQuery('(min-width: 640px)')

  const submitCallback = useCallback(() => {
    const uploader = fileUploader.current.instance
    const value = uploader.option('value')
    const file = value ? value[0] : null
    submit(file)
  }, [submit, fileUploader])

  const file = new File([defaultValue], defaultValue, { type: 'application/pdf' })
  const showBtn = defaultValue || !required

  return (
    <>
      <FileUploader
        ref={fileUploader}
        accept={accept}
        multiple={false}
        uploadMode='useForm'
        onValueChanged={submitCallback}
        validationMessageMode='always'
        defaultValue={defaultValue ? [file] : []}
        readyToUploadMessage={defaultValue ? 'Cambiar archivo' : 'Subir archivo'}
      >
        <Validator>
          {required ? <RequiredRule message='Este campo es requerido' /> : undefined}
        </Validator>
      </FileUploader>

      {
            showBtn
              ? (
                <Button
                  ref={button}
                  width={isLargeScreen ? 138 : '100%'}
                  className='mt-5'
                  icon='arrowright'
                  type='success' style={{ backgroundColor: '#40c0c0' }}
                  text='Continuar'
                  onClick={defaultValue ? next : submitCallback}
                />
                )
              : undefined
    }

    </>

  )
}

FileField.propTypes = {
  question: PropTypes.object.isRequired,
  submit: PropTypes.func.isRequired,
  next: PropTypes.func.isRequired
}

export default FileField
